import community from './community-400.webp'
import empowering from './empowering-400.webp'
import fantasy from './fantasy-climax-400.webp'
import immersive from './immersive-audio-400.webp'
import inclusive from './inclusive-400.webp'
import informative from './informative-400.webp'

const Icons = {
  community,
  empowering,
  fantasy,
  immersive,
  inclusive,
  informative
}

export default Icons